import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { screens } from "../config/routes";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * ProtectedRoute component that handles authentication protection for routes.
 * Redirects to login if user is not authenticated.
 *
 * @param {ProtectedRouteProps} props - The component props
 * @returns {JSX.Element} The protected route component
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { currentUser } = useSelector((state: RootState) => state.auth);
  const location = useLocation();

  if (!currentUser) {
    // Save the attempted URL to redirect back after login
    return <Navigate to={screens.login} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
